import { Empty, Steps } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  formatDateUtcToCurrent,
  formatDateUtcToCurrentTz,
} from "../../utils/utils";
import { useDispatch } from "react-redux";
import { getActivityLogs } from "../../../core/store/reducers/activity-log.slice";
import { getUsersDetails } from "../../../core/store/reducers/auth.slice";

interface UpdatedUser {
  fullName: string;
}

interface ActivityEntry {
  subject: string;
  newValue?: string;
  oldvalue?: string;
  newvalue?: string;
  contents?: string;
  updatedUserDetails?: UpdatedUser[];
  [key: string]: any;
}

interface FieldChange {
  fieldCode: string;
  fieldName: string;
  oldValue: string | null;
  newValue: string | null;
}

interface FormattedActivity {
  subject: string;
  fieldName: string;
  oldValue: string;
  newValue: string;
  content: any;
  updatedBy: string;
  [key: string]: any;
}

type ActivityStep = {
  title: string;
  description: string | React.ReactNode;
  status: string;
};

type ActivityLogProps = {
  
  id?: string;
  record?: any;
  module?: any;
};
const ActivityLogComponent: React.FC<ActivityLogProps> = ({
  id,
  record,
  module
}: ActivityLogProps) => {
  const dispatch = useDispatch();
  const [activityLogs, setActivityLogs] = useState<any[]>([]);
  const [activityLogData, setActivityLogData] = useState<any[]>([]);
  const [userDetails, setUserDetails] = useState<any>({})

  useEffect(() => {
    if (id ) {
      fetchActivityLog();
      fetchUserDetails();
    }
  }, []);

  
  const fetchUserDetails = async () => {
    const response = await dispatch(getUsersDetails({ids: [record.createdBy]})).unwrap();
    console.log(response?.data, "getUsersDetails")
    if (response?.data[0]) {
      setUserDetails(response?.data[0])
    }
  };

  const fetchActivityLog = async () => {
    const response = await dispatch(getActivityLogs(id)).unwrap();
    if (response?.data?.data) {
      setActivityLogData(response?.data?.data);
      console.log(response?.data?.data, "fetchActivityLog");
    }
  };

  const isJson = (str: string | undefined): boolean => {
    if (!str) return false;
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    setActivityLogs([]);
    handleFormatActivity();
  }, [activityLogData,userDetails]);

  const handleFormatActivity = () => {
    const arrResponse: FormattedActivity[] = [];

    

    activityLogData.forEach((entry: any) => {
      const {
        subject,
        newValue,
        contents,
        updatedUserDetails,
        oldvalue,
        newvalue,
      } = entry;
      const updatedBy = updatedUserDetails?.[0]
        ? `${updatedUserDetails[0].fullName} `
        : "System";

      if (subject.includes("Update") && isJson(newValue) && JSON.parse(newValue)?.length) {
        const parsedChanges: FieldChange[] = JSON.parse(newValue as string);

        parsedChanges.forEach((change) => {
          const { fieldCode, fieldName } = change;

          // Only include changed fields
          if (change.oldValue !== change.newValue) {
            let oldVal = change.oldValue ?? "";
            let newVal = change.newValue ?? "";

            // Check if values are valid date strings
            const isOldDate = moment(oldVal, moment.ISO_8601, true).isValid();
            const isNewDate = moment(newVal, moment.ISO_8601, true).isValid();

            if (isOldDate) {
              oldVal = moment.utc(oldVal).local().format("DD-MMM-YYYY");
            }

            if (isNewDate) {
              newVal = moment.utc(newVal).local().format("DD-MMM-YYYY");
            }

            arrResponse.push({
              ...entry,
              subject: subject,
              fieldName: fieldName,
              oldValue: oldVal,
              newValue: newVal,
              content: isJson(contents) ? JSON.parse(contents as string) : {},
              updatedBy: updatedBy,
            });
          }
        });
      } else {
        // Handle simple audit logs
        arrResponse.push({
          ...entry,
          fieldName: subject,
          oldValue: oldvalue ?? "",
          newValue: newvalue ?? "",
          content: isJson(contents) ? JSON.parse(contents as string) : {},
          updatedBy: updatedBy,
          created_date: formatDateUtcToCurrent(record?.createdDate)
        });
      }
    });

    arrResponse.push({
      subject: `${module} Created`,
      fieldName: "",
      oldValue: "",
      newValue: "",
      content: '',
      updatedBy: userDetails.fullName ? userDetails?.fullName : '',
      created_date: record.createdDate
    });
    setActivityLogs(arrResponse);
    console.log(arrResponse, "arrResponse");
  };

  return (
    <>
    <Steps
      direction="vertical"
      size="small"
      current={activityLogs.length}
      items={activityLogs.map((step, index) => ({
        title: (
          <>
            <div>{(step.oldValue || step.newValue) ? step.fieldName : step.subject}</div>
            {(step.oldValue || step.newValue) && (
              <div className="weight-600">
                {step.oldValue && step.newValue && (
                  <>
                    {step.oldValue} → {step.newValue}
                  </>
                )}

                {step.oldValue && !step.newValue && (
                  <>
                    {step.oldValue} →{" "}
                    <span style={{ color: "red" }}>Removed</span>
                  </>
                )}

                {!step.oldValue && step.newValue && (
                  <>
                    Added:{" "}
                    <span>{step.newValue}</span>
                  </>
                )}
              </div>
            )}
          </>
        ),

        description: `by ${step.updatedBy || "---"} | ${
          step.created_date
            ? formatDateUtcToCurrent(step.created_date, "DD-MMM-YYYY hh:mm A")
            : ""
        }`,
        // status: step.status as any,
        icon:
          step.status === "error" ? (
            <div
              style={{
                color: "#ff4d4f",
                border: "1px solid #ff4d4f",
                borderRadius: "50%",
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
              }}
            >
              {index + 1}
            </div>
          ) : undefined,
      }))}
    />
    {activityLogs?.length === 0 && 
      <Empty/>
    }
    </>
    
  );
};

export default ActivityLogComponent;
